import type { InvestorContactSearchResult } from '@/types/investor';
import { contactFullName } from './existingContactMapping';

interface CopySourceNoteProps {
  source: InvestorContactSearchResult;
}

export function CopySourceNote({ source }: CopySourceNoteProps) {
  return (
    <p className="text-sm text-muted-foreground">
      Copied from {contactFullName(source)} at {source.investor_name}. Changes
      here don&apos;t affect the original. Primary contact, signatory rights and
      portal access are not copied.
    </p>
  );
}
